// App — T062 + T067
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import MonitorDetail from './pages/MonitorDetail';
import Settings from './pages/Settings';
import ImportExport from './pages/ImportExport';
import Users from './pages/Users';
import StatusPages from './pages/StatusPages';
import StatusPageEdit from './pages/StatusPageEdit';
import PublicStatusPage from './pages/PublicStatusPage';
import PublicMonitorDetail from './pages/PublicMonitorDetail';
import OAuthCallback from './pages/OAuthCallback';
import WarRoom from './pages/WarRoom';

function ProtectedRoute() {
  const { user, isLoading } = useAuth();
  if (isLoading) {
    return (
      <div className="min-h-screen bg-bg-primary flex items-center justify-center">
        <div className="animate-pulse text-text-secondary">Loading...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <Outlet />;
}

function AdminRoute() {
  const { isAdmin, isLoading } = useAuth();
  if (isLoading) {
    return (
      <div className="min-h-screen bg-bg-primary flex items-center justify-center">
        <div className="animate-pulse text-text-secondary">Loading...</div>
      </div>
    );
  }
  if (!isAdmin) return <Navigate to="/" replace />;
  return <Outlet />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public pages — no auth */}
        <Route path="/login" element={<Login />} />
        <Route path="/oauth-callback" element={<OAuthCallback />} />
        <Route path="/status/:slug" element={<PublicStatusPage />} />
        <Route path="/status/:slug/monitors/:monitorId" element={<PublicMonitorDetail />} />
        {/* Legacy /s/ redirects */}
        <Route path="/s/:slug" element={<PublicStatusPage />} />
        <Route path="/s/:slug/:monitorId" element={<PublicMonitorDetail />} />

        {/* Authenticated pages */}
        <Route element={<ProtectedRoute />}>
          {/* War Room — no sidebar layout */}
          <Route path="/warroom" element={<WarRoom />} />

          <Route element={<Layout />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/monitors/:id" element={<MonitorDetail />} />

            {/* Admin pages */}
            <Route element={<AdminRoute />}>
              <Route path="/settings" element={<Settings />} />
              <Route path="/import-export" element={<ImportExport />} />
              <Route path="/users" element={<Users />} />
              <Route path="/status-pages" element={<StatusPages />} />
              <Route path="/status-pages/:id" element={<StatusPageEdit />} />
            </Route>
          </Route>
        </Route>

        {/* Catch-all */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
